import type { ReactNode } from "react";
import { cn } from "@/lib/cn";

export interface LabeledFieldProps {
  etiqueta: string;
  htmlFor: string;
  error?: string | null;
  ayuda?: string;
  className?: string;
  children: ReactNode;
}

/** Etiqueta + control + ayuda/error. Los ids de ayuda/error son `${htmlFor}-ayuda` / `${htmlFor}-error`. */
export function LabeledField({ etiqueta, htmlFor, error, ayuda, className, children }: LabeledFieldProps) {
  return (
    <div className={cn("flex flex-col gap-1.5", className)}>
      <label htmlFor={htmlFor} className="text-chico font-medium text-texto">
        {etiqueta}
      </label>
      {children}
      {error ? (
        <p id={`${htmlFor}-error`} className="text-chico text-peligro">
          {error}
        </p>
      ) : ayuda ? (
        <p id={`${htmlFor}-ayuda`} className="text-chico text-texto-suave">
          {ayuda}
        </p>
      ) : null}
    </div>
  );
}
